"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./StrategyEditor.css");
var _reactResponsiveModal = _interopRequireDefault(require("react-responsive-modal"));
var _reactDropdown = _interopRequireDefault(require("react-dropdown"));
require("react-dropdown/style.css");
var _InputBox = _interopRequireDefault(require("./InputBox/InputBox.js"));
var _HoldingsEditor = _interopRequireDefault(require("./HoldingsEditor/HoldingsEditor.js"));
var _axios = _interopRequireDefault(require("axios"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _i18n = _interopRequireDefault(require("../../util/i18n.js"));
var _ImportantInfoModal = _interopRequireDefault(require("./ImportantInfoModal/ImportantInfoModal.js"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const SUM_TOLERANCE = 0.001;
const StrategyEditor = _ref => {
  let {
    strategyToEdit = null,
    closeEditor = null,
    checkTickersUrl = 'https://dpd.wisdomtree.com',
    benchmarks = [],
    token = null,
    clientEmail,
    dataspanApiUrl = 'https://dataspanapi.wisdomtree.com',
    typeHeadPlaceholder = null,
    type = "create",
    buttonLabel = "New Portfolio",
    savedStrategyCallBack,
    showInfoModal,
    closeModalOnSave = false,
    appName = 'Digital Portfolio Developer',
    disableUpdate = false
  } = _ref;
  const today = new Date();
  const initialBenchmark = strategyToEdit !== null && strategyToEdit !== void 0 && strategyToEdit.benchmarks ? {
    label: strategyToEdit.benchmarks.slice(-1)[0].name,
    value: strategyToEdit.benchmarks.slice(-1)[0].externalID
  } : null;
  const initialPeriodicity = strategyToEdit !== null && strategyToEdit !== void 0 && strategyToEdit.periodicity ? {
    label: strategyToEdit.periodicity,
    value: strategyToEdit.periodicity
  } : {
    label: 'Annual',
    value: 'Annual'
  };
  const initialName = strategyToEdit ? strategyToEdit.name : "Portfolio ".concat(today.getFullYear(), "-").concat((today.getMonth() + 1).toString().padStart(2, '0'), "-").concat(today.getDate().toString().padStart(2, '0'));
  const [name, setName] = (0, _react.useState)(initialName);
  const [periodicity, setPeriodicity] = (0, _react.useState)(initialPeriodicity.value);
  const [dirty, setDirty] = (0, _react.useState)(false);
  const [updatedHoldings, setUpdatedHoldings] = (0, _react.useState)(null);
  const [selectedBenchmark, setSelectedBenchmark] = (0, _react.useState)(initialBenchmark);
  const [rerunAnalysis, setRerunAnalysis] = (0, _react.useState)(false);
  const [showEditor, setShowEditor] = (0, _react.useState)(false);
  const [showImportantInfoModal, setShowImportantInfoModal] = (0, _react.useState)(false);
  const [isSaving, setIsSaving] = (0, _react.useState)(false);
  const [sumWeights, setSumWeights] = (0, _react.useState)(0);
  const [sumWeightsError, setSumWeightsError] = (0, _react.useState)(false);
  const [duplicateTickersError, setDuplicateTickersError] = (0, _react.useState)(false);
  const handleSumWeightsUpdate = sum => {
    setSumWeights(sum);
  };
  const clearFields = () => {
    setName('new strategy');
    setDirty(false);
    setUpdatedHoldings(null);
    setRerunAnalysis(false);
  };
  const handleCloseModal = function () {
    let savedData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let isSaving = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    clearFields();
    setSumWeightsError(false);
    setDuplicateTickersError(false);
    setShowEditor(false);
    if (closeEditor) closeEditor();
    if (savedStrategyCallBack) savedStrategyCallBack(savedData, isSaving);
  };
  const saveNewStrategy = async fieldsToUpdate => {
    const url = "".concat(dataspanApiUrl, "/personalstrategies/");
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': "Token ".concat(token)
    };
    try {
      const response = await _axios.default.post(url, fieldsToUpdate, {
        headers
      });
      return response.data;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  };
  const updateExistingStrategy = async fieldsToUpdate => {
    if (!fieldsToUpdate.holdings) {
      var _strategyToEdit$holdi;
      const lastHolding = (_strategyToEdit$holdi = strategyToEdit.holdings) === null || _strategyToEdit$holdi === void 0 ? void 0 : _strategyToEdit$holdi[strategyToEdit.holdings.length - 1];
      if (lastHolding) {
        fieldsToUpdate.holdings = [{
          tickers: lastHolding.tickers,
          weights: lastHolding.weights
        }];
      } else {
        console.error('No holdings found to update');
      }
    }
    const url = "".concat(dataspanApiUrl, "/personalstrategies/").concat(strategyToEdit.id, "/");
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': "Token ".concat(token)
    };
    try {
      const response = await _axios.default.put(url, fieldsToUpdate, {
        headers
      });
      return response.data;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  };
  const handleSave = async () => {
    setSumWeightsError(false);
    setDuplicateTickersError(false);
    if (!dirty) return;
    if (closeModalOnSave) {
      savedStrategyCallBack({
        id: 0,
        name: name
      }, true);
      setShowEditor(false);
    }
    setDirty(false);
    setIsSaving(true);
    let formattedHoldings = null;
    let totalValue = strategyToEdit ? strategyToEdit.totalValue : 1000000;
    if (updatedHoldings) {
      formattedHoldings = [{
        tickers: updatedHoldings.map(holding => holding.ticker),
        weights: updatedHoldings.map(holding => holding.weight)
      }];
      totalValue = updatedHoldings.reduce((sum, holding) => sum + holding.amount, 0);
    } else if (rerunAnalysis && strategyToEdit.holdings.slice(-1)[0]) {
      formattedHoldings = [{
        tickers: strategyToEdit.holdings.slice(-1)[0].tickers,
        weights: strategyToEdit.holdings.slice(-1)[0].weights
      }];
    }

    // Check for duplicate tickers
    // const allTickers = formattedHoldings ? formattedHoldings[0].tickers : [];
    // const tickerSet = new Set(allTickers);
    // if (tickerSet.size !== allTickers.length) {
    //   setDuplicateTickersError(true);
    //   setIsSaving(false);
    //   return;
    // }

    const fieldsToUpdate = {
      clientEmail: clientEmail,
      name: name || strategyToEdit.name,
      periodicity: periodicity,
      holdings: formattedHoldings,
      benchmarkExternalID: (selectedBenchmark === null || selectedBenchmark === void 0 ? void 0 : selectedBenchmark.value) || null,
      totalValue: totalValue
    };
    if (strategyToEdit && strategyToEdit.id) {
      fieldsToUpdate.id = strategyToEdit.id;
    }
    try {
      let response;
      if (type === 'update') {
        response = await updateExistingStrategy(fieldsToUpdate);
      } else {
        response = await saveNewStrategy(fieldsToUpdate);
      }
      handleCloseModal(response, false);
    } catch (error) {
      setIsSaving(false);
    } finally {
      setIsSaving(false);
    }
  };
  const handleNameEdit = value => {
    setName(value);
    setDirty(true);
  };
  const handleSelectPeriodicity = event => {
    setPeriodicity(event.value);
    setDirty(true);
  };
  const handleUpdateHoldings = holdings => {
    setUpdatedHoldings(holdings);
    setDirty(true);
    setRerunAnalysis(true);
  };
  const handleSelectBenchmark = benchmark => {
    setSelectedBenchmark(benchmark);
    setDirty(true);
    setRerunAnalysis(true);
  };
  const renderButtonOrIcon = () => {
    if (showInfoModal) {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "new-portfolio-button",
        onClick: () => setShowImportantInfoModal(true)
      }, buttonLabel);
    }
    if (type === 'create') {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "new-portfolio-button",
        onClick: () => setShowEditor(true)
      }, buttonLabel);
    } else if (type === 'update') {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "menu-button",
        onClick: () => disableUpdate ? null : setShowEditor(true)
      }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _freeSolidSvgIcons.faEdit,
        size: "lg",
        color: disableUpdate ? 'transparent' : 'currentColor'
      }));
    }
    return null;
  };
  const initialHoldings = strategyToEdit ? strategyToEdit.holdings.slice(-1)[0] : null;
  const totalValue = strategyToEdit ? strategyToEdit.totalValue : 1000000;
  const periodicityOptions = ['Quarterly', 'Monthly', 'Annual'];
  const benchmarkOptions = benchmarks.filter(benchmark => !selectedBenchmark || benchmark.externalID !== selectedBenchmark.value).map(benchmark => ({
    label: benchmark.name,
    value: benchmark.externalID,
    className: 'wt-dropdown-option'
  }));
  if (selectedBenchmark) {
    benchmarkOptions.unshift({
      label: 'None',
      value: null,
      className: 'wt-dropdown-option'
    });
  }
  if (showImportantInfoModal) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "strategy-blend-editor-landing"
    }, /*#__PURE__*/_react.default.createElement(_ImportantInfoModal.default, {
      isOpen: showImportantInfoModal,
      onClose: () => {
        setShowImportantInfoModal(false);
        setShowEditor(true);
      },
      appNam: appName
    }));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "strategy-blend-editor-landing"
  }, renderButtonOrIcon(), showEditor && /*#__PURE__*/_react.default.createElement(_reactResponsiveModal.default, {
    open: showEditor,
    onClose: () => {
      handleCloseModal(null);
    },
    showCloseIcon: false,
    classNames: {
      overlay: 'modal-overlay',
      modal: 'strategy-blend-editor'
    },
    closeOnOverlayClick: false,
    closeOnEsc: false,
    center: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "strategy-blend-editor-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "inputs"
  }, /*#__PURE__*/_react.default.createElement(_InputBox.default, {
    value: name,
    onChange: handleNameEdit,
    onBlur: undefined,
    editLabel: 'edit-name'
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "periodicity"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "periodicity-text"
  }, "Select rebalance frequency"), /*#__PURE__*/_react.default.createElement(_reactDropdown.default, {
    controlClassName: "wt-dropdown-periodicity",
    arrowClassName: "wt-dropdown-arrow",
    menuClassName: "wt-dropdown",
    options: periodicityOptions,
    placeholder: 'select-a-periodicity',
    onChange: handleSelectPeriodicity,
    value: periodicity
  })), /*#__PURE__*/_react.default.createElement(_HoldingsEditor.default, {
    initialHoldings: initialHoldings,
    checkTickersUrl: checkTickersUrl,
    updateHoldings: handleUpdateHoldings,
    benchmarks: benchmarks,
    totalValue: totalValue,
    token: token,
    clientEmail: clientEmail,
    dataspanApiUrl: dataspanApiUrl,
    typeHeadPlaceholder: typeHeadPlaceholder,
    updateSumWeightsCallback: handleSumWeightsUpdate
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "other-inputs"
  }, benchmarks.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "benchmarks"
  }, /*#__PURE__*/_react.default.createElement(_reactDropdown.default, {
    controlClassName: "wt-dropdown",
    arrowClassName: "wt-dropdown-arrow",
    menuClassName: "wt-dropdown",
    options: benchmarkOptions,
    placeholder: 'select-a-benchmark',
    onChange: handleSelectBenchmark,
    value: selectedBenchmark
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "action-buttons-fundchar"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: () => Math.abs(sumWeights - 1) > SUM_TOLERANCE ? setSumWeightsError(true) : handleSave(),
    disabled: !(dirty && (updatedHoldings || initialHoldings)) || isSaving
  }, isSaving ? /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faSpinner,
    spin: true
  }) : 'save'), /*#__PURE__*/_react.default.createElement("button", {
    onClick: () => handleCloseModal(null),
    disabled: isSaving
  }, "cancel")), sumWeightsError && /*#__PURE__*/_react.default.createElement("p", {
    className: "weights-warning"
  }, _i18n.default.t('weights-error')), duplicateTickersError && /*#__PURE__*/_react.default.createElement("p", {
    className: "weights-warning"
  }, _i18n.default.t('duplicate-tickers-error')))));
};
var _default = exports.default = StrategyEditor;